import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Icons, SVG } from '../../../components/atoms/SVG';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { Heading } from '../Heading/Heading';

export function ReadAllAccessBanner({ disableReadAllModeRoute }: { disableReadAllModeRoute: string }) {
  const { t } = useSonTranslation('ReadAllAccessBanner');
  return (
    <section className="read-all-access-banner font-regular-15-19" role="alert" aria-labelledby="read-all-access-name">
      <span className="read-all-access-banner__icon">
        <SVG svgSpriteId={Icons.FEEDBACK_ERROR} />
      </span>
      <div className="read-all-access-banner__message-container">
        <Heading hierarchy={2} className="read-all-access-banner__heading font-bold-15-19" id="read-all-access-name">
          {t('readAllAccessActive')}:{' '}
        </Heading>
        <em className="read-all-access-banner__message">
          <span>{t('readAllAccessActiveMessage')}</span>{' '}
          <Hyperlink to={disableReadAllModeRoute} className="read-all-access-banner__link" routing={false}>
            {t('readAllAccessActivate')}
          </Hyperlink>
        </em>
      </div>
    </section>
  );
}
